import React from 'react';
import T from 'prop-types';
import { Link } from 'react-router-dom';
import { Dropdown, Menu } from 'antd';

import UserPlanTag from '../userPlanTag';

import { Name, StyledMenu, UserIcon, ApiIcon, CreditCardIcon, LogoutIcon, User, Avatar, DownIcon } from './style';

const UserMenu = ({ fullName, initials, logout }) => (
  <Dropdown
    className="user-menu-dropdown"
    id="user-menu-dropdown"
    overlay={
      <StyledMenu>
        <Menu.Item key="name" disabled>
          <Name>{fullName}</Name>
          <UserPlanTag />
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="settings">
          <Link to="/settings/account">
            <UserIcon />
            Account
          </Link>
        </Menu.Item>
        <Menu.Item key="api">
          <Link to="/settings/api">
            <ApiIcon />
            API
          </Link>
        </Menu.Item>
        <Menu.Item key="billing">
          <Link to="/settings/billing">
            <CreditCardIcon />
            Billing
          </Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="logout" onClick={logout}>
          <LogoutIcon />
          Logout
        </Menu.Item>
      </StyledMenu>
    }
    shape="round"
    size="large"
  >
    <User>
      <Avatar>{initials}</Avatar>
      <DownIcon />
    </User>
  </Dropdown>
);
UserMenu.propTypes = {
  logout: T.func.isRequired,

  fullName: T.string.isRequired,
  initials: T.string.isRequired,
};

export default UserMenu;
